<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

        <div class="data-list-container">
            <div class="">
                <vs-popup style="" class="holamundo"  title="Elija la materia a cargar" :active.sync="popupActive">
                    <p>   <v-select label="ncompleto" v-model="agregar_select" :options="grupos"></v-select>
                        <br/>
                        <vs-button  class="float-right"  @click="agregar_alumno()">Cargar</vs-button>
                    </p>
                </vs-popup>

            </div>
            <h2>Carga de materias</h2>
            <div style="margin: 10px;">
                <p>{{cuatrimestre_actual[0].nombre}} {{cuatrimestre_actual[0].idAgno}}</p><br>
            </div>
                <vs-button class=""  @click="cargar_materia()">Cargar Materia</vs-button>

            <vs-table style="margin: 40px;" :data="carga_actual">
                <template slot="thead">
                    <vs-th>Materia</vs-th>
                    <vs-th>Grupo</vs-th>
                    <vs-th>Profesor</vs-th>
                    <vs-th>Acciones</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].id">
                            {{data[indextr][0].nombre}}
                        </vs-td>
                        <vs-td :data="data[indextr].id">
                          (  {{data[indextr][0].idCuatrimestre}}{{data[indextr][0].digito_b}} )
                        </vs-td>
                        <vs-td :data="data[indextr].id">
                            {{data[indextr][0].nombres}}   {{data[indextr][0].apellidoPaterno}}   {{data[indextr][0].apellidoMaterno}}
                        </vs-td>

                        <vs-td :data="data[indextr].id">
                            <vs-button @click="openConfirm(data[indextr][0].id_AlumnoGrupo)" color="danger" type="gradient">Descargar</vs-button>
                        </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
            <p></p>
        </div>
</template>

<script>
    import AddNewDataSidebar from './AddNewDataSidebar.vue';
    import vSelect from 'vue-select'
    import Button from "../components/vuesax/button/Button";
    export default {
        components: {
            Button,
            AddNewDataSidebar,
            'v-select': vSelect,
        },
        data() {
            return {
                matricula: localStorage.getItem('matricula'),
                carrera: localStorage.getItem('id_carrera'),
                id : localStorage.getItem('id'),
                alumno_detalle: [],
                cuatrimestre_actual: [{ nombre: "", idAgno: "" }],

                materias: [],
                grupos: [],
                selected: [],
                agregar_select: '',
                verifica_pago : 0,
                users: [],
                cargo_materias : 0,
                carga_actual: [],
                itemsPerPage: 25,
                popupActive: false,
                isMounted: false,
                addNewDataSidebar: false,
            }
        },
        computed: {
            currentPage() {
                if(this.isMounted && this.cargo_materias == 0) {
                    //return this.$refs.table.currentx
                }
                return 0
            },
        },
        methods: {

            agregar_alumno(){
                console.log(this.agregar_select)
                this.$http.get("agregar_alumno_grupo/" + this.agregar_select.id_grupo + "/" + this.id).then(
                    response => {
                        //location.reload();
                        // console.log(response.data)
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Grupo Agregado',
                            text: 'Se ha agregado el grupo correctamente'
                        })
                        this.popupActive = false
                        this.traer_carga()

                        //this.alumnos_grupo = response.data.alumnos_grupo;
                        //console.log(this.kardex);

                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },
            cargar_materia(){
                this.popupActive=true
            },
            openConfirm(grupo) {
                // alert(grupo)
                localStorage.setItem("grupo_a_quitar", grupo)
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Confirmar`,
                    text: '¿Seguro que desea descargar la materia?',
                    accept: this.acceptAlert
                })
            },
            acceptAlert() {

                this.$vs.notify({
                    color: 'danger',
                    title: 'Materia Descargada',
                    text: 'La materia se ha descargado correctamente'
                })
                this.$http.get("quitar_alumnoGrupo/" + localStorage.getItem("grupo_a_quitar") ).then(
                    response => {
                        //  location.reload();
                        // console.log(response.data)
                        //   this.getAlumnosGrupo()
                        //this.alumnos_grupo = response.data.alumnos_grupo;
                        //console.log(this.kardex);
                        this.traer_carga();

                    },
                    error => {
                        this.StepError(error);
                    }
                );

            },

            getCuatrimestreActual(){
                this.$http.get("cuatrimestre_actual").then(
                    response => {
                        // console.log(response.data)
                        this.cuatrimestre_actual = response.data.cuatrimestre_actual;
                        //console.log(this.kardex);
                        //this.getCarreras();
                        //
                        //
                        this.traer_carga();
                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },
            traer_carga(){
                this.$http.get("get_carga_periodo/" + this.id + "/" + this.cuatrimestre_actual[0].idAgno + "/" + this.cuatrimestre_actual[0].idPeriodo).then(
                    response => {
                        // console.log(response.data)
                        // this.materias = this.formatData(response.data.materias);
                        // console.log(this.alumno_detalle);

                        ////  this.materias = this.materias[10]
                        const resultArray = Object.keys(response.data.carga).map(function(key) {
                            return [ response.data.carga[key]];
                        });

                        this.carga_actual = resultArray
                        this.$vs.loading.close();
                        this.getMateriasPosibles();

                        if(this.carga_actual.length>0){
                            this.cargo_materias = 1;
                        }




                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },


            getMateriasPosibles() {
                this.$http.get("grupos_periodo/" + this.carrera + "/" + this.cuatrimestre_actual[0].idAgno + "/" + this.cuatrimestre_actual[0].idPeriodo).then(
                    response => {
                        // console.log(response.data)
                        this.grupos = response.data.grupos;
                        //console.log(this.kardex);

                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },


        },
        created() {
            this.$vs.loading();
            this.carrera =  localStorage.getItem('id_carrera');
            this.getCuatrimestreActual();

        },
        mounted() {
            this.isMounted = true;

        },

    }
</script>